@use "Styles/mixins";

:host {
    box-sizing: border-box;
    line-height: 1;
}

.vm-card {
    &__inner {
        background: mixins.get-color(background, bg-gray-100);
        border-radius: 16px;
    }
    &__avatar {
        flex-shrink: 0;
    }

    &__body {
        display: flex;
        align-items: center;
        gap: 16px;
        padding: 16px;
    }

    &__text {
        flex-grow: 1;
    }

    &__cta {
        flex-shrink: 0;
    }

    &__description {
        border-top: 2px solid mixins.get-color(background, bg-white);
        padding: 12px 16px 16px;
    }
}
